import { Config } from '@models/config.model';
import { createAction, props } from '@ngrx/store';

// Get Years
export const getAllowedVehicleYearsRequest = createAction(
    '[Data] Get Allowed Vehicle Years Request'
);
export const getAllowedVehicleYearsFailure = createAction(
    '[Data] Get Allowed Vehicle Years Failure',
    props<{ error: string }>()
);
export const getAllowedVehicleYearsSuccess = createAction(
    '[Data] Get Allowed Vehicle Years Success',
    props<{ years: number[] }>()
);

// Get Config
export const getConfigRequest = createAction(
    '[Data] Get Config Request'
);
export const getConfigFailure = createAction(
    '[Data] Get Config Failure',
    props<{ error: string }>()
);
export const getConfigSuccess = createAction(
    '[Data] Get Config Success',
    props<{ config: Config }>()
);
